import { CASE_STATUS_OPTIONS } from "../../../../constants/submissionSummaryOptions";

export const allCaseStatusOptions = CASE_STATUS_OPTIONS.map((option) => ({
  label: option.text,
  value: option.id,
}));
